import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'

import type { OpenPositionCardProps } from './types'

export default function OpenPositionCard({
	country,
	title,
	description,
	readMoreUrl,
	readMoreLabel = 'Read more',
	isExternal = false
}: OpenPositionCardProps) {
	return (
		<div className="flex h-auto flex-col gap-3 rounded-xs bg-black-50 p-6">
			<span className="w-fit whitespace-nowrap rounded-2xl bg-brand-200 px-4 py-1.5 body-small text-black-950">
				{country}
			</span>
			<h2 className="h4 text-black-950">{title}</h2>
			<p className="body-small text-black-950">{description}</p>
			<div className="py-2">
				<Button variant="link" href={readMoreUrl} isExternal={isExternal}>
					{readMoreLabel}
					{isExternal ? (
						<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
					) : (
						<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
					)}
				</Button>
			</div>
		</div>
	)
}
